/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardApprenantNonInscritsDto
 */
export interface DashboardApprenantNonInscritsDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardApprenantNonInscritsDto
     */
    apprenant?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DashboardApprenantNonInscritsDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idmetier?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idstade?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idcontrat?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardApprenantNonInscritsDto
     */
    codeContrat?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idpri?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantNonInscritsDto
     */
    idari?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardApprenantNonInscritsDto
     */
    masquee?: boolean;
}

/**
 * Check if a given object implements the DashboardApprenantNonInscritsDto interface.
 */
export function instanceOfDashboardApprenantNonInscritsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardApprenantNonInscritsDtoFromJSON(json: any): DashboardApprenantNonInscritsDto {
    return DashboardApprenantNonInscritsDtoFromJSONTyped(json, false);
}

export function DashboardApprenantNonInscritsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardApprenantNonInscritsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'apprenant': !exists(json, 'apprenant') ? undefined : json['apprenant'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'codeContrat': !exists(json, 'codeContrat') ? undefined : json['codeContrat'],
        'idpri': !exists(json, 'idpri') ? undefined : json['idpri'],
        'idari': !exists(json, 'idari') ? undefined : json['idari'],
        'masquee': !exists(json, 'masquee') ? undefined : json['masquee'],
    };
}

export function DashboardApprenantNonInscritsDtoToJSON(value?: DashboardApprenantNonInscritsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'apprenant': value.apprenant,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'idmetier': value.idmetier,
        'idstade': value.idstade,
        'idcontrat': value.idcontrat,
        'codeContrat': value.codeContrat,
        'idpri': value.idpri,
        'idari': value.idari,
        'masquee': value.masquee,
    };
}

